
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fhs-marketing-opportunities",
      function () {
        return require("private-next-pages/fhs-marketing-opportunities.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fhs-marketing-opportunities"])
      });
    }
  